export * from './viewreservation.component';


// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/viewreservation/index.ts